/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable radix */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SafeHtml } from '@angular/platform-browser';

import { DataService } from '../services/dataService/data.service';
import { GlobalVariable } from '../../app/global';
import { LocalStorageService } from '../services/core/local-storage.service';
import {
  AlertController,
  IonContent,
  IonList,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { PickupTimePage } from '../models/pickup-time/pickup-time.page';
import { ItemPreviewPage } from '../item-preview/item-preview.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import {
  AppSelectionOptions,
  LaunchNavigator,
  LaunchNavigatorOptions,
  RememberChoiceOptions,
} from '@awesome-cordova-plugins/launch-navigator/ngx';
import {
  NativeGeocoder,
  NativeGeocoderOptions,
  NativeGeocoderResult,
} from '@ionic-native/native-geocoder/ngx';
import { Platform } from '@ionic/angular';
import { UserApiService } from '../services/user-api.service';
import { UserLocationPage } from '../user-location/user-location.page';
import { LoginModalPage } from '../login-modal/login-modal.page';
import { UserQrPage } from '../user-qr/user-qr.page';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SupercategoriesPage } from '../supercategories/supercategories.page';
import { DineinTablePage } from '../dinein-table/dinein-table.page';
import { RewardNotificationPage } from '../reward-notification/reward-notification.page';
import { CONFIG } from '../services/app-config.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { OrderTypeSelectionPage } from '../order-type-selection/order-type-selection.page';
import { el } from 'date-fns/locale';
import { ThankyouPage } from '../thankyou/thankyou.page';
import { LocationService } from '../services/location.service';
declare let google;
@Component({
  selector: 'app-order',
  templateUrl: './order.page.html',
  styleUrls: ['./order.page.scss'],
})
export class OrderPage implements OnInit, AfterViewInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren(IonList, { read: ElementRef }) list: QueryList<ElementRef>;
  @ViewChild('nav2') nav2!: ElementRef;
  listItems = [];
  segmentSelect = 'pickup';
  pickupTime;
  businessDetail: any;
  userAddress: any;
  slidesOptions = {
    slidesPerView: 1,
    autoplay: true,
    loop: true,
    speed: 300,
  };
  day: any;
  businessReviews = [];
  time: any;
  date: any;
  activeSuperID: any;
  scrollAmount = 0;
  section: NodeListOf<HTMLElement>;
  li: NodeListOf<Element>;
  Randomcolor: string;
  itemCustomId: any;
  indexArray = [];
  currentY: any;
  scrollY: any;
  scrollEvent = true;
  s_day: any;
  s_time: any;
  Total: number;

  today_message: any;
  bannerSection;
  totalInterval: any;
  accordionIcon = true;
  accordionValue: any;
  selectedSuperCategory: any;
  socialLinks: any;
  hourType = 'hour';
  customerName: any;

  isSchoolOrder = false;
  showSchoolPopup = false;
  isDelivery: boolean;
  isBranches: boolean;
  locationStatus: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public globals: GlobalVariable,
    public modalController: ModalController,
    public server: UserApiService,
    private geoLocation: Geolocation,
    public aib: InAppBrowser,
    private launchNavigator: LaunchNavigator,
    public zone: NgZone,
    public nav: NavController,
    public alertController: AlertController,
    public popoverCtrl: PopoverController,
    private sanitize: DomSanitizer,
    private el: ElementRef,
    private localStorageService: LocalStorageService,
    private nativeStorage: NativeStorage,
    private locationService: LocationService
  ) {
    
    this.globals.OrderType = localStorage.getItem('orderType');
    console.log('orders','constructor'+localStorage.getItem('isOrderTypeChange'));
    if (localStorage.getItem('isOrderTypeChange') == 'true') {
      this.globals.isOrderTypeChange = true
    } else {
      this.globals.isOrderTypeChange = false
    }

    this.businessDetail = this.globals.businessData;
    // have to comment this getCategory call before build
    if (
      this.globals.hostName != 'localhost' &&
      this.globals.inWeb &&
      !this.businessDetail
    ) {
      this.globals.inWeb = true;
      this.getHostData();
    }

    if (this.globals.inWeb) {
      this.bannerSection = document.getElementById('bannerweb');
    }


    if(localStorage.getItem('orderType') == 'delivery'){
      this.isDelivery = true
      this.globals.OrderType = 'delivery'
      console.log('testing','calllllled delivery');
    }else{
      this.isDelivery = false
      this.globals.OrderType = 'pickup'
      console.log('testing','calllllled pickup');
    }
    console.log('000000','calllllled',
      globals.businessData.pickup,
      globals.dine_in
    );
  }

  ionViewDidLeave() {
    console.log('orders','ionVIewDidLeave');
    clearInterval(this.globals.itemInterval);
    
  }
  getBusinessAgain() {

    this.server.getBusiness().subscribe((res) => {
      if (res.status == 'true') {
        this.globals.businessData = res.results[0];
        this.globals.businessName = this.globals.businessData.name;
        this.globals.businessId = this.globals.businessData.business_id;
        this.globals.qrEnabled = this.globals.businessData?.app_qr;
        if (this.globals.qrEnabled == undefined) {
          this.globals.qrEnabled = true;
        }

        this.globals.point_check = this.globals.businessData.points_enabled;
        this.globals.MenuStyle = this.globals.businessData.menu_style;
        this.globals.punch_check = this.globals.businessData.punches_enabled;
        this.globals.special_offer = this.globals.businessData.special_offer;
        this.globals.events_enabled = this.globals.businessData.events_enabled;
        this.globals.dineInEnabled = this.globals.businessData.dine_in;
        this.globals.gallery_enabled =
          this.globals.businessData.gallery_enabled;
        this.globals.pickup = this.globals.businessData.pickup;
        this.globals.franchise_enabled =
          this.globals.businessData.franchise_enabled;
        this.globals.b_type = this.globals.businessData.b_type;
        this.globals.businessHost = this.globals.businessData.marketing_url[0];
        this.globals.latitude = this.globals.businessData.latitude;
        this.globals.longitude = this.globals.businessData.longitude;
        this.globals.menu_ready_msg =
          this.globals.businessData.menu_ready_message;
        this.globals.hours_operation =
          this.globals.businessData.hours_operation;
        this.globals.branch_enabled = this.globals.businessData.branch_enabled;
        this.globals.giftcard_enabled =
          this.globals.businessData.giftcard_enabled;
        this.globals.b_logo = this.globals.businessData.logo;
        this.globals.home_logo = this.globals.businessData.logo;

        this.globals.business_name = this.globals.businessData.name;
        this.globals.business_phone = this.globals.businessData.phone;
        this.globals.business_address = this.globals.businessData.address;
        this.globals.StripId = this.globals.businessData.stripe_id;
        this.globals.order_instructions =
          this.globals.businessData.instructions_enabled;
        this.globals.pickup_timing = this.globals.businessData.pickup_timing;
        this.globals.delivery_timing =
          this.globals.businessData.delivery_timing;
        this.globals.business_username = this.globals.businessData.username;
        this.globals.estimated_time = this.globals.businessData.delivery_time;
        this.globals.business_discount_count = parseInt(
          this.globals.businessData.business_discount_count
        );
        this.globals.username = this.globals.businessData.username;
        this.globals.bussinessId = this.globals.businessData.business_id;
        this.globals.admin_stripe =
          this.globals.businessData.admin_stripe_enabled;
        this.globals.pickupsetting = this.globals.businessData.delivery_time;
        this.globals.tax = this.globals.businessData.tax;
        this.globals.deliveryCharges = this.globals.businessData.delivery_fee;
        this.globals.cardDeliveryFee = this.globals.businessData.card_delivery_fee;

        this.globals.pickup_Time = this.globals.businessData.pickup_time;
        this.globals.minimun_order = parseInt(
          this.globals.businessData.minimum_order
        );
        this.globals.availed_discount_count = parseInt(
          this.globals.businessData.customer_discount_availed_count
        );
        this.globals.paypalId = this.globals.businessData.paypal_id;
        this.globals.Timing = this.globals.businessData.hours_operation;
        this.globals.specific_delivery_day =
          this.globals.businessData.specific_delivery_day;
        this.globals.review_enabled = this.globals.businessData.review_enabled;
        this.globals.delivery_day = this.globals.businessData.delivery_day;
        this.globals.authorize_enabled =
          this.globals.businessData.authorize_enabled;
        this.globals.card_enabled = this.globals.businessData.card_enabled;
        this.globals.admin_stripe_enabled =
          this.globals.businessData.admin_stripe_enabled;
        this.globals.catering_enabled =
          this.globals.businessData.catering_enabled;
        this.globals.catering_cart_enabled =
          this.globals.businessData.catering_cart_enabled;
        this.globals.giftcard_amount_limit =
          this.globals.businessData.giftcard_limit;
        this.globals.business_type = this.globals.businessData.business_type;
        this.globals.appointment_enabled =
          this.globals.businessData.appointment_enabled;
        this.globals.website = this.globals.businessData.website;
        this.globals.orders_enabled = this.globals.businessData.orders_enabled;
        this.globals.BusinessDiscount = parseInt(
          this.globals.businessData.discount
        );
        this.globals.ccFeeDisclaimer =
          this.globals.businessData.ccFeeDisclaimer;
        this.globals.tip_enabled = this.globals.businessData.tip_enabled;
        this.globals.menu_ready = this.globals.businessData.menu_ready;
        this.globals.delivery_time = this.globals.businessData.delivery_time;
        this.globals.doordashEnabled =
          this.globals.businessData.doordash_enabled;
        this.globals.loyaltyEnabled = this.globals.businessData.loyalty;
        this.globals.reservationEnabled = this.globals.businessData.reservation;

        // platform fee data;
        this.globals.platformFeeEnabled =
          this.globals.businessData.platformFeeEnabled;
        this.globals.platformFeeAmount =
          this.globals.businessData.platformFeeAmount;
        this.globals.platformFeeLabel =
          this.globals.businessData.platformFeeLabel;
        //scheduling
        this.globals.schedule_enabled =
          this.globals.businessData.schedule_enabled;
        // display_menu
        this.globals.display_menu = this.globals.businessData.display_menu;

        document.getElementById('title').innerHTML =
          this.globals.businessData.name;
        //  setting favicon
        const favicon = document.getElementById('favicon_main');
        favicon.setAttribute('href', this.globals.b_logo);

        if (this.globals.pickup == '1') {
          this.globals.pickup = true;
        } else {
          this.globals.pickup = false;
        }

        if (this.globals.businessData.delivery == '1') {
          this.globals.delivery = true;
        } else {
          this.globals.delivery = false;
        }

        if (this.globals.businessData.cash_enabled == '1') {
          this.globals.cash_enabled = true;
        } else {
          this.globals.cash_enabled = false;
        }

        if (this.globals.pickup == '1') {
          this.globals.pickup = true;
        } else {
          this.globals.pickup = false;
        }

        if (this.globals.businessData.delivery == '1') {
          this.globals.delivery = true;
        } else {
          this.globals.delivery = false;
        }

        this.getParamsFromUrl();

        if (this.globals.inWeb == true) {
          this.globals.inWeb = true;

          this.getCategories();
          this.getReviews();
        }
        this.loadBanner();
        if (this.globals.businessData.appColor) {
          this.globals.appColor = this.globals.businessData.appColor;
          document.documentElement.style.setProperty(
            '--ion-color-primary',
            this.globals.appColor
          );
        } else {
          // this.globals.appColor = '#000000'
        }
      }
    });
  }
  loadBanner() {
    const response = this.server.LoadBanners();
    response.subscribe(
      (data) => {
        this.globals.isDataLoaded = true;

        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        this.globals.cash_discount = data.cash_discount;
        this.globals.banners = data.data;
        this.globals.ring_image = data.ring_image;
        this.globals.cash_discount_enabled = data.cash_discount_enabled;
        this.globals.cash_discount_percentage = data.cash_discount_percentage;
        this.globals.cash_discount_value = data.cash_discount_value;
        if (data.theme_color) {
          this.globals.appColor = data.theme_color;

          document.documentElement.style.setProperty(
            '--ion-color-primary',
            this.globals.appColor
          );
        } else {
          // this.globals.appColor = '#000000'
        }

        this.globals.cash_discount = data.cash_discount;

        this.globals.cash_discount_enabled = data.cash_discount_enabled;
        this.globals.cash_discount_percentage = data.cash_discount_percentage;
        this.globals.cash_discount_value = data.cash_discount_value;
      },
      (error) => {
        // let alert = this.alertCtrl.create({
        //     message: 'Seems like your Network is not providing service. Try recharging',
        //     buttons: ['OK']
        // })
        // alert.present();
      }
    );
  }
  async reward_notification() {
    const orderFrom = sessionStorage.getItem('orderFrom');
    if (orderFrom == 'school') {
      const mobile_update = await this.modalController.create({
        component: RewardNotificationPage,
        componentProps: {
          data: '',
          callFrom: 'school',
        },
        mode: 'ios',
        cssClass: 'message_POP',
        swipeToClose: true,
      });
      mobile_update.present();
    } else {
      const response = this.server.reward_notification();
      response.subscribe(
        async (data) => {
          if (data.status == true) {
            this.globals.notifications = data.notifications;
            this.globals.showPromoModal = false;
            const mobile_update = await this.modalController.create({
              component: RewardNotificationPage,
              componentProps: {
                data: data.notifications,
                callFrom: '',
              },
              mode: 'ios',
              cssClass: 'message_POP',
              swipeToClose: true,
            });
            mobile_update.present();
          }
        },
        (error) => { }
      );
    }
  }
  switchSuper(item) {
    this.selectedSuperCategory = item;
    this.globals.Homecategories = this.selectedSuperCategory.categories;
    if (this.globals.inWeb) {
      this.activeSuperID = this.globals.Homecategories[0].category_id;
    }
  }

  ngAfterViewInit() {
    console.log('orders','ngAfterViewInit');
    setTimeout(() => {
      const date = new Date();
      const day = date.getDay();

      if (this.globals.hours_operation && this.globals.hours_operation[day]) {
        const current_day = this.globals.hours_operation[day];
        this.today_message = current_day[2];
      }
    }, 2000);
    this.list.changes.subscribe((_) => {
      this.listItems = this.list.toArray();
    });

  }
  ngOnInit(): void {
    console.log('orders','ngOnInit');
    if (this.globals.inWeb) {
      const orderFrom = sessionStorage.getItem('orderFrom');
      const val = JSON.parse(sessionStorage.getItem('showInfoPopup'));
      this.showSchoolPopup = val ? val : false;
      if (orderFrom == 'school') {
        this.isSchoolOrder = true;
      }
      const cartData = localStorage.getItem('cart');
      
      if (cartData != 'null' && cartData != null && cartData != 'undefined') {
        this.globals.itemsInCart = JSON.parse(cartData);
        setTimeout(() => {
          this.totalCalculate();
        }, 500);
      }
      console.log('bsunines',CONFIG.business_id);

      this.getCategories();

    }
    
    // this.getBranches()

  }



  getBranches() {
    this.server.getBusinessBranches(this.globals.mycoordinates).subscribe(
      (res) => {
        if (res.status == 'true') {
          this.isBranches = true;
          
        } else {
          this.isBranches = false;
        }        
      },
      (err) => {
      }
    );
  }

  ionViewWillEnter() {
    console.log('orders','ionViewWillEnter');

    if (this.globals.inWeb) {
      const orderFrom = sessionStorage.getItem('orderFrom');
      const val = JSON.parse(sessionStorage.getItem('showInfoPopup'));
      this.showSchoolPopup = val ? val : false;
      if (orderFrom == 'school') {
        this.isSchoolOrder = true;
      }

    }
    this.globals.dismiss();
    const schleDate: any = localStorage.getItem('scheduled_time');
    console.log('check time', schleDate);

    if (schleDate) {
      this.globals.myDate = schleDate;

      this.pickupTime = schleDate;
      this.convertDate(this.pickupTime);
    }

    this.globals.takeMeToCart = false;

    if (this.globals.inWeb && !this.globals.myDate) {
      this.day = '';
      this.time = '';
      this.date = '';
      this.pickupTime = undefined;
    }

    if (this.globals.orderOnCall) {
      this.customerName = this.localStorageService.getFirstName('FirstName');
      if (this.globals.OrderType == 'delivery') {
        this.segmentSelect = 'delivery';
      } else {
        this.segmentSelect = 'pickup';
      }

      if (this.globals.OrderType == 'delivery') {
        const address = localStorage.getItem('deliveryAddress');
        if (address != null && address != undefined) {
          this.globals.DeliveryAddress = address;
          this.geoCode(this.globals.DeliveryAddress);
          console.log('location', address);
        } else {
          console.log('location', this.globals.businessData.address);
        }

        if (this.globals.DeliveryAddress == '') {
          console.log('location', address);

          this.getLocation();

        }
      }

      if (this.globals.myDate) {
        this.pickupTime = this.globals.myDate;
        this.convertDate(this.globals.myDate);
      }
    }

    if (this.globals.businessData) {

      if (this.globals.scrollEvents == 'scroll') {
        this.scrollEvent = false;
      }
      if (this.globals.inWeb) {
        this.scrollEvent = false;
      }
      if (
        this.globals.businessData.pickup != '1' &&
        this.globals.businessData.delivery == '1'
      ) {
        this.globals.OrderType = 'delivery';
      }
      // this.globals.itemInterval = setInterval(() => {
      //   this.totalCalculate();
      // }, 1000);
      this.time_change();
      this.totalCalculate();

      this.globals.superCategories.forEach((supercategories) => {
        supercategories.isAvailabe = this.checkTiming(
          supercategories?.hours_operation
        );
        supercategories.categories.forEach((category) => {
          category.isAvailabe = this.checkTiming(category.timings);
          category.items.forEach((item) => {
            // item.background = this.getColor();
            item.isAvailabe = this.checkTiming(item?.item_timings);
          });
        });
      });
      this.li = document.querySelectorAll('.links');
      this.section = document.querySelectorAll('section');
      this.activeSuperID = this.globals.activeSuperCatID;
      if (this.globals.selectedCategory != undefined) {
        this.setActive();
      }

    }
    if (this.globals.catering_enabled) {
      this.pickupTime = this.globals.myDate;
      this.convertDate(this.globals.myDate);
    }
    if (this.globals.OrderType == 'delivery') {
      this.segmentSelect = 'delivery';
      this.globals.OrderType = 'delivery'
    } else {
      this.globals.OrderType = 'pickup'
      this.segmentSelect = 'pickup';
    }
  }
  ionViewDidEnter() {
    console.log('orders','ionViewDidEnter');

    const kiosk_flag = JSON.parse(localStorage.getItem('kiosk'));

    this.globals.kiosk_flag = kiosk_flag;

    if (!this.globals.inWeb) {
      this.getCategories();
      this.selectedSuperCategory = this.globals.superCategories[0];
      this.globals.Homecategories = this.selectedSuperCategory.categories;
    } else {
      if (this.globals.superCategories.length == 0 && this.businessDetail) {
        this.getCategories();
      }
    }

    if (this.globals.inWeb && this.globals.showPromoModal) {
      this.globals.isCategoryData = false;
      this.reward_notification();
    }
    if (this.globals.inWeb && this.businessDetail) {
      this.getReviews();
    }
    this.getSocials();
  }
  //for web
  getHostData() {
    // CONFIG.business_id = '';

    this.server.getHostInfo().subscribe((res) => {
      this.globals.webMetaData = res;
      CONFIG.business_id = res.business_id;
      CONFIG.business_username = res.username;
      CONFIG.splash_image = res.logo;
      CONFIG.splash_text = res.name;
      this.globals.header_data = res?.header_data;
      this.globals.footer_data = res?.footer_data;

      if (res?.footer_data) {
        this.loadScriptFromServer(res?.footer_data);
      }
      this.getBusinessAgain();
    });
  }

  allBnsMenu: any;
  activeSuperCatId: any;
  allmenuCatsArr: any[] = [];

  getCategories() {
    console.log('appCategories','2nd call');
    this.time_change();
    this.globals.superCategories = [];
    this.globals.Homecategories = [];
    console.log('calling', 'order page' + CONFIG.business_id);

    this.server.getCategories().subscribe(
      (res) => {
        this.globals.dismiss();
        this.allmenuCatsArr = [];
        if (res.super_categories && res.super_categories.length > 0) {
          this.allBnsMenu = res.super_categories;
          this.globals.superCategories = res.super_categories;
          this.globals.Homecategories = this.globals.superCategories[0]?.categories;
          this.allBnsMenu.forEach((cat: any) => {
            if (cat.categories && cat.categories.length > 0) {
              cat.categories.forEach((item: any) => {
                this.allmenuCatsArr.push(item);
              });
            }
          });
          this.activeSuperCatId = res.super_categories[0].id;
        }

        this.globals.scrollEvents = res.restaurant.app_menu;

        this.globals.superCategories = res.super_categories;
        if (this.globals.superCategories.length > 0) {
          this.selectedSuperCategory = this.globals.superCategories[0];
          if (this.selectedSuperCategory.categories.length > 0) {
            this.globals.Homecategories = this.selectedSuperCategory.categories;

            this.globals.activeSuperCatID = this.globals.Homecategories[0].category_id;
            if (this.globals.inWeb) {
              this.activeSuperID = this.globals.Homecategories[0].category_id;
            }
          }

          this.globals.superCategories.forEach((supercategory) => {
            supercategory.isAvailabe = this.checkTiming(supercategory?.hours_operation);
            supercategory.categories.forEach((category) => {
              category.isAvailabe = this.checkTiming(category.timings);
              category.items.forEach((item) => {
                item.isAvailabe = this.checkTiming(item.item_timings);
              });
            });
          });

          this.activeSuperID = this.globals.activeSuperCatID;
          if (this.globals.selectedCategory !== undefined) {
            this.setActive();
          }
          if (this.globals.scrollEvents === 'scroll') {
            this.scrollEvent = false;
          }
          if (this.globals.inWeb) {
            this.scrollEvent = false;
          }
          if (!this.globals.isOrderTypeChange) {

            console.log('type change', 'api');

            if (this.globals.businessData.pickup !== '1' && this.globals.businessData.delivery === '1' && !this.globals.dine_in) {
              this.globals.OrderType = 'delivery';
            }

            if (this.globals.queryParamsFromUrl.hasOwnProperty('type')) {
              if (this.globals.businessData.delivery === '1' && this.globals.queryParamsFromUrl.type.toLowerCase() === 'delivery') {
                this.globals.OrderType = 'delivery';
              }
              if (this.globals.businessData.pickup === '1' && this.globals.queryParamsFromUrl.type.toLowerCase() === 'pickup') {
                this.globals.OrderType = 'pickup';
              }
            }
          } else {
            console.log('type change', 'local');
            this.globals.OrderType = localStorage.getItem('orderType');
            
        
          }


          this.globals.itemInterval = setInterval(() => {
            if (this.globals.dine_in && this.globals.dineInEnabled) {
              if (!this.globals.isOrderTypeChange) {
                this.globals.OrderType = 'dine_in';
              }
              this.globals.businessData.pickup = '0';
              this.globals.businessData.delivery = '0';
            }
          }, 1000);

          this.totalCalculate();

          this.globals.superCategories.forEach((supercat) => {
            supercat.isAvailabe = this.checkTiming(supercat?.hours_operation);
            supercat.categories.forEach((category) => {
              category.isAvailabe = this.checkTiming(category.timings);
              category.items.forEach((item) => {
                item.isAvailabe = this.checkTiming(item?.item_timings);
              });
            });
          });

          this.li = document.querySelectorAll('.links');
          this.section = document.querySelectorAll('section');

          this.activeSuperID = this.globals.activeSuperCatID;

          if (this.globals.selectedCategory !== undefined) {
            this.setActive();
          }
        }

        if (this.globals.inWeb && this.globals.dineInEnabled) {
        }
        console.log('testingggg', 'first time' + this.globals.superCategories);
      },
      (err) => {
        this.globals.dismiss();
        this.globals.presentToast('Network Error, try again');
      }
    );
  }

  async selectTable() {
    const alert = await this.alertController.create({
      header: 'Hold On',
      message: 'No Table Selected!',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Proceed Anyway',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Select Table',
          handler: () => {
            this.dineTableSelection();
          },
        },
      ],
    });

    await alert.present();
  }
  async addToCart(item) {
    if (item.in_stock) {
      // if(this.globals.itemsInCart.length==0){
      if (
        this.globals.businessData.pickup != '1' &&
        this.globals.businessData.delivery != '1' &&
        !this.globals.dine_in
      ) {
        this.globals.presentToast(
          'We\'re not offering online ordering right now. please try again later. Sorry for inconvenience !',
          'middle'
        );
        return;
      }
      if (this.globals.OrderType == 'dine_in' && !this.globals.dineInTable) {
        this.selectTable();
      }

      // this.globals.businessInCartId=this.Business_id
      const orderFrom = sessionStorage.getItem('orderFrom');
      if (orderFrom == 'school' || this.globals.orderOnCall) {
        this.Cart(item);
      }
      else {
        if (this.globals.OrderType == 'delivery') {
          if (this.checkTimingItem(this.globals.delivery_timing)) {
            this.Cart(item);
          }
        } else {
          if (this.checkTimingItem(this.globals.pickup_timing)) {
            this.Cart(item);
          }
        }
      }
    } else {
      this.globals.presentToast('This item is sold out');
    }
  }
  async Cart(item) {
    this.globals.itemsInCart.push({
      menuId: '1',
      restId: this.globals.bussinessId,
      uniqueId: item.id,
      menuItem: item.name,
      image: item.image,
      category_tax: item.category_tax,
      quantity: 1,
      itemInstructions: '',
      price: Number(item.price).toFixed(2),
      totalPrice: Number(item.price).toFixed(2),
      menuExtrasSelected: [],
      menuUpsellItemsSelected: [],
      upsell_calculated: false,
      reward: false,
      reward_id: '',
      tax: item.tax,
      tax_enabled: item.tax_enabled,
      tax_inclusive: item?.tax_inclusive,
      discount_value: item.discount_value,
      discount_type: item.discount_type,
      attributeId: item.attribute_id, //changed on mon 28 aug by rameez , invalid variable name was used
      basePrice: Number(item.price).toFixed(2),
    });

    localStorage.setItem('cart', JSON.stringify(this.globals.itemsInCart));
    this.totalCalculate();
    // this.globals.presentToast('Added in Cart','middle');
  }
  totalCalculate() {
    if (this.globals.itemsInCart.length > 0) {
      this.Total = 0;
      let amount_without_tax = 0;
      for (const sub of this.globals.itemsInCart) {
        this.Total = Number(this.Total);
        sub.totalPrice = Number(sub.totalPrice);
        this.Total += Number(sub.totalPrice);
        if (sub.tax_enabled == 'false' || sub.tax_enabled == false) {
          amount_without_tax += Number(sub.totalPrice);
        }
        this.globals.ProductsTotal = this.Total;
      }
    } else {
      this.globals.ProductsTotal = 0;
    }
  }
  time_change() {
    const scheduled_time_ = localStorage.getItem('scheduled_time');
    if (scheduled_time_ && scheduled_time_ != 'undefined') {
      const response = this.server.date_convert(scheduled_time_);
      response.subscribe(
        (data) => {
          if (data.success == true) {
            this.globals.s_day = data.day_id + 1;
            this.globals.s_time = data.time;
          }
        },
        (error) => {
          this.globals.presentToast(
            'Something went wrong check your internet connection.'
          );
        }
      );
    } else {
    }
  }

  goTo(path) {
    if (this.globals.businessId == '356') {
      this.globals.opneReview();
    } else {
      if (this.globals.isloggedIn == true) {
        this.router.navigate([path]);
      } else {
        this.globals.loginmodal();
      }
    }
  }

  ionViewWillLeave() {
    this.globals.selectedCategory = undefined;
  }
  changeSuperCat(e) {
    if (this.globals.inWeb) {
      this.activeSuperID = e.detail.value;
    }
  }

  changeSegment(ev: any) {
    this.globals.OrderType = ev.detail.value;
    localStorage.setItem('orderType', this.globals.OrderType);
    localStorage.setItem('isOrderTypeChange', 'true');
    console.log('ordertype',ev.detail.value);
    if (this.globals.OrderType == 'delivery') {
      this.isDelivery = true;
      const address = localStorage.getItem('deliveryAddress');
      if (address != null && address != undefined) {
        this.globals.DeliveryAddress = address;
        this.geoCode(this.globals.DeliveryAddress);
      }
      else{
        this.globals.DeliveryAddress = this.globals.businessData.address;
        this.geoCode(this.globals.DeliveryAddress);

      }
      if (this.globals.DeliveryAddress == '') {
        this.getLocation();
      }
    }else{
      this.isDelivery = false;
    }
  }


  scrollFunc(id, id2?) {
    const scrollID = document.getElementById(id);

    this.content.scrollToPoint(0, scrollID.offsetTop, 200);
    // this.scroll3(id2);
  }

  //custom event for scroll 99 using ion content
  customScrollEventHandler(scrolldata) {
    this.currentY = scrolldata;
    let len = this.section.length;
    while (--len && scrolldata + 20 < this.section[len].offsetTop) { }

    this.li.forEach((i) => {
      i.classList.remove('active');
    });
    this.li[len].classList.add('active');
    const id = this.li[len].getAttribute('id');

    this.scroll2(id);
  }
  scrollEnd(e) {
    // document.getElementById('tabs').style.display='flex';
  }

  activeMenuCat: any;
  scrollHandler(event) {
    const contentElement = this.el.nativeElement.querySelector('#content');
    const cards = contentElement.querySelectorAll('.superCategoriesDiv');
    const menuCards = contentElement.querySelectorAll('.catMenuDiv');

    // Loop through each card and check if it's in the viewport
    cards.forEach((card: any) => {
      const rect = card.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (isVisible) {
        // Extract card ID from the ID attribute
        const cardId = card.id.split('-')[1];

        if (this.activeSuperCatId != cardId) {
          this.activeSuperCatId = cardId;
        }
      }
    });

    // Loop through each card and check if it's in the viewport
    menuCards.forEach((card: any) => {
      const rect = card.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (isVisible) {
        // Extract card ID from the ID attribute
        const cardId = card.id.split('-')[1];

        if (this.activeMenuCat != cardId) {
          this.activeMenuCat = cardId;

          // this.allmenuCatsArr.map((items: any) => {
          //   if (
          //     items.category_id == this.activeMenuCat &&
          //     items.items &&
          //     items.items.length > 6 &&
          //     this.isScrollActive
          //   ) {

          //     this.scroll2(this.activeMenuCat);
          //   }
          // });
        }
      }
    });
  }

  isScrollActive = false;
  scrollToSuperCat(cardId: number) {
    const contentElement = this.el.nativeElement.querySelector('#content');
    const cardElement = this.el.nativeElement.querySelector('#card-' + cardId);
    if (cardElement) {
      cardElement.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth',
      });
    }
    this.isScrollActive = false;

    this.activeSuperCatId = cardId;
  }

  scrollToMenu(catId: any) {
    const cardElement = this.el.nativeElement.querySelector('#menu-' + catId);
    if (cardElement) {
      cardElement.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth',
      });
    }
    this.isScrollActive = false;

    this.activeMenuCat = catId;
  }

  lastId: any;
  prevScrollPos: any = 0;

  dirction: any;

  scroll2(id) {
    if (this.lastId != id) {
      this.lastId = id;
      document.getElementById('nav-' + id).scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center',
      });
    }

    const scrollerHeight = this.nav2.nativeElement.scrollWidth;
  }

  getColor() {
    const symbols = '0123456789ABCDEF';

    let color = '#';
    for (let i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }

    return color;
  }
  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }
  imageReplace(item) {
  }

  openCart() {
    // if (this.globals.OrderType == 'delivery') {
    //   if (this.globals.DeliveryAddress == '') {
    //     this.showAlert(
    //       'Location Required',
    //       'Location services are turned off. Please enable location to continue.'
    //     );
    //   } else {
    //     this.router.navigate(['/new-cart']);
    //   }
    // } else {
      this.router.navigate(['/new-cart']);
    // }

    clearInterval(this.globals.itemInterval);
  }

  private async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK'],
    });
    await alert.present();
  }
  sortDesc(desc: any, spliceIndex: any) {
    if (!desc) {
      return '';
    }

    if (desc && desc.length > spliceIndex) {
      const da = desc.substring(0, spliceIndex);
      return da + '...';
    } else {
      return desc;
    }
  }

  openItem2(event: MouseEvent, item: any) {
    const clickedElementId = (event.target as HTMLElement).id;
    if (clickedElementId == 'btn1' || clickedElementId == 'btn2') {
    } else {
      this.openItem(item);
    }
  }

  async openItem(menuitem) {
    if (menuitem.in_stock) {
      if (
        this.globals.businessData.pickup != '1' &&
        this.globals.businessData.delivery != '1' &&
        !this.globals.dine_in
      ) {
        this.globals.presentToast(
          'We\'re not offering online ordering right now. please try again later. Sorry for inconvenience !',
          'middle'
        );
        return;
      }
      if (this.globals.OrderType == 'dine_in' && !this.globals.dineInTable) {
        this.selectTable();
      }
      clearInterval(this.globals.itemInterval);

      this.globals.businessMenuItem = menuitem;
      this.globals.itemDetail = menuitem;

      const modal = await this.modalController.create({
        component: ItemPreviewPage,
        cssClass: 'itemPreviewPage',
        mode: 'ios',
        componentProps: { data: menuitem },
      });

      await modal.present();

      modal.onDidDismiss().then((res) => {
        this.totalCalculate();
      });
    } else {
      this.globals.presentToast('This item is sold out');
    }
  }
  setActive() {
    if (this.globals.superCategories.length == 1) {
      setTimeout(() => {
        const elem = document
          .getElementById(this.globals.selectedCategory.category_id)
          .scrollIntoView();
        // elem.scrollIntoView()
      }, 1000);
    } else {
      if (this.scrollEvent == false) {
        this.activeSuperID = this.globals.selectedCategory.id;
        setTimeout(() => {
          document
            .getElementById(this.globals.selectedCategory.id + 's')
            .scrollIntoView();
        }, 1000);
        // document.getElementById(this.globals.selectedCategory.category_id+'s').scrollIntoView();

        // document.getElementById(this.globals.selectedCategory.id).scrollIntoView();
      } else {
        setTimeout(() => {
          document
            .getElementById(this.globals.selectedCategory.id)
            .scrollIntoView({
              behavior: 'auto',
              // inline:'center',
            });
        }, 1000);
      }
    }
  }
  navigateTo() {
    // this.launchNavigator.appSelection
    const rememberChoice: RememberChoiceOptions = {
      enabled: false,
    };
    const appSelection: AppSelectionOptions = {
      list: [
        this.launchNavigator.APP.GOOGLE_MAPS,
        this.launchNavigator.APP.WAZE,
        this.launchNavigator.APP.APPLE_MAPS,
        this.launchNavigator.APP.YANDEX,
        this.launchNavigator.APP.CITYMAPPER,
      ],
      rememberChoice,
    };

    const options: LaunchNavigatorOptions = {
      // start: this.globals.address,
      appSelection,
    };
    if (this.globals.businessData.address) {
      this.launchNavigator
        .navigate(this.globals.businessData.address, options)
        .then(
          (success) => {
            // this.launchNavigator.appSelection.userChoice.clear(()=>{
            // });
          },
          (error) => {
            //   this.launchNavigator.appSelection.userChoice.clear(()=>{
            // });
            // this.globals.presentToast('Failed to navigate');
            const link =
              'https://www.google.com/maps?q=' +
              this.globals.businessData.address;
            // dfghjk
            // this.aib.create(link);
            window.open(link, '_blank').focus();
          }
        );
    }
    // this will clear user selection..... will add to settings later.
  }
  getmapImage(location) {
    const loc = location.replace(/ /g, '+');
    const address = `https://maps.googleapis.com/maps/api/staticmap?center=${loc}&zoom=16&size=400x360&markers=${location}&key=AIzaSyCDFSak5czCvHjYNhIg0puzcFVzWAc2TPw&q`;
    const url = this.sanitize.bypassSecurityTrustResourceUrl(address);
    return url;
  }
  seeBusinessLocation() {
    this.router.navigate(['/business-location']);
  }
  async seeUserLocation() {
    const modal = await this.modalController.create({
      component: UserLocationPage,
      componentProps: {},
      cssClass: 'delivery_modal',
      mode: 'ios',
    });
    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (!res.data) {
        if (
          this.globals.businessData.pickup != '1' &&
          this.globals.businessData.delivery == '1'
        ) {
          this.segmentSelect = 'delivery';
          this.globals.OrderType = 'delivery';
          console.log('data','deilvery');
          
        } else {
          console.log('data','pickup');
          this.segmentSelect = 'pickup';
          this.globals.OrderType = 'pickup';
        }
      }
    });
  }
  async showPickupModel() {
    const modal = await this.modalController.create({
      component: PickupTimePage,
      cssClass: 'customize_pickupModel',
      mode: 'ios',
      componentProps: { pickup: this.pickupTime },
    });
    modal.onDidDismiss().then((res) => {
      if (this.globals.pickup_Time == 'now') {
        this.pickupTime = undefined;
      } else {
        this.pickupTime = res.data.pickup;

        this.convertDate(this.pickupTime);
      }
      this.getCategories();

    });
    return await modal.present();
  }
  min_date_value() {
    const date = new Date();

    let datenow = date.getDate().toString();
    // var datenow  =moment().format('YYYY-MM-DD HH:mm');

    let month = (date.getMonth() + 1).toString();
    const year = date.getFullYear().toString();

    if (month.length < 2) { month = '0' + month; }
    if (datenow.length < 2) { datenow = '0' + datenow; }
    const value = year + '-' + month + '-' + datenow;
    value.toString();

    // var date1 = moment().format('YYYY-MM-DD HH:mm');
    const date1 = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    const dateNow = date1;
    if (!this.globals.myDate) {
      this.globals.myDate = date1;

      localStorage.setItem('scheduled_time', this.globals.myDate);
    }
  }
  convertDate(date) {
    this.server.date_convert(date).subscribe(
      (data) => {
        this.day = data.day;
        const parsed = Date.parse(date);
        let time = data.time;
        time = time.split('.');
        const hours = time[0];
        const mins = time[1];

        (this.time = this.tConvert(hours + ':' + mins)),
          (this.date = data.date);
      },
      (err) => { }
    );
  }
  tConvert(time) {
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM ' : ' PM '; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }
  getLocation() {
    this.globals.presentToast('Getting location...');
    this.geoLocation.getCurrentPosition().then(
      (position) => {
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.reverseGeoCoding();
      },
      (err) => {
        this.globals.presentToast('Failed to get location, try again');
      }
    );
  }

  geoCode(address: any) {
    console.log('geoCode',address);
    
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        ',' +
        results[0].geometry.location.lng();
      this.reverseGeoCoding();
    });
  }
  reverseGeoCoding() {
    const response = this.server.getAddress(this.globals.mycoordinates);
    let myadress = '';
    response.subscribe(
      (data) => {
        myadress = data.address;
        if (data.in_radius) {
          localStorage.setItem('deliveryAddress', myadress);
          this.globals.DeliveryAddress = myadress;
          if (this.globals.doordashEnabled) {
            this.globals.presentToast(
              '$' +
              data.delivery_meta.delivery_fee +
              ' Would be charged as delivery fee.',
              3000
            );
            this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
            this.globals.cardDeliveryFee = data.delivery_meta.card_delivery_fee;

            this.globals.businessData.delivery_fee =
              data.delivery_meta.delivery_fee;
            this.globals.businessData.card_delivery_fee = data.delivery_meta.card_delivery_fee;
          }
          // new ...... dec2022
          else {
            this.globals.presentToast(
              '$' +
              data.delivery_meta.delivery_fee +
              ' Would be charged as delivery fee.',
              3000
            );
            this.globals.deliveryCharges = data.delivery_meta.delivery_fee;
            this.globals.cardDeliveryFee = data.delivery_meta.card_delivery_fee;

            this.globals.businessData.delivery_fee =
              data.delivery_meta.delivery_fee;
            this.globals.businessData.card_delivery_fee = data.delivery_meta.card_delivery_fee;

          }
          // new ...... dec2022

          this.globals.inradius = data.in_radius;
        } else {
          this.globals.presentToast(
            'Your location is not in delivery radius.please change or switch to pickup',
            'middle'
          );
          this.seeUserLocation();
        }
      },
      (error) => {
        this.globals.presentToast('Please Turn on your location.');
      }
    );
  }
  checkTimingItem(timing) {
    if (this.globals.order_time == 'schedule') {
      if (this.globals.specific_delivery_day == 'true') {
        return true;
      }

      let day = this.globals.schedule_day_id + 1;
      if (day == 7) {
        day = 0;
      }

      var time = this.globals.schedule_converted_time;
      var current_day = timing[day];
      var n = current_day[0].indexOf('.');

      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }

      var n1 = current_day[1].indexOf('.');

      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      if (
        (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
        (Number(current_day[0]) <= time &&
          Number(current_day[1]) < Number(current_day[0]))
      ) {
        return true;
      } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
        return true;
      } else {
        this.globals.presentToast(
          'Sorry, we are not serving ' +
          this.globals.OrderType +
          ' at time you schedule!'
        );
        return false;
      }
    } else {
      const date = new Date();
      const day1: any = date.getDay();
      var time: any = date.getHours() + '.' + date.getMinutes();
      time = Number(time);

      var current_day = timing[day1];
      var n = current_day[0].indexOf('.');

      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }

      var n1 = current_day[1].indexOf('.');

      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      if (
        (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
        (Number(current_day[0]) <= time &&
          Number(current_day[1]) < Number(current_day[0]))
      ) {
        return true;
      } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
        return true;
      } else {
        this.globals.presentToast(
          'Sorry, we are not serving ' +
          this.globals.OrderType +
          ' at this time!'
        );
        return false;
      }
    }
  }


  changeAccordion(e, name) {
    if (this.accordionValue == name && e.detail.value) {
      this.accordionValue = undefined;
    } else {
      this.accordionValue = name;
    }
  }

  checkTiming(Timing) {
    if (Timing) {
      const scheduled_time_ = localStorage.getItem('scheduled_time');
      let date: any;
      let time: any;
      let day: any;
      if (
        this.globals.order_time == 'schedule' &&
        scheduled_time_ &&
        scheduled_time_ != null
      ) {
        day = this.globals.s_day;
        time = this.globals.s_time;
      } else {
        date = new Date();
        day = date.getDay();
        time = date.getHours() + '.' + date.getMinutes();
      }

      if (day == 7) {
        day = 0;
      }

      const current_day = Timing[day];
      const n = current_day[0].indexOf('.');
      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }
      const n1 = current_day[1].indexOf('.');
      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      time = Number(time);
      if (current_day) {
        if (
          (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
          (Number(current_day[0]) <= time &&
            Number(current_day[1]) < Number(current_day[0]))
        ) {
          return true;
        } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
  async openQRMODAL() {
    const login = JSON.parse(this.localStorageService.getLogin('isLogin'))
    if (login) {
      const modal = await this.modalController.create({
        component: UserQrPage,
        componentProps: { data: {} },
        backdropDismiss: true,
        cssClass: 'QRModal',
        animated: true,
        swipeToClose: true,
        mode: 'ios',
      });
      await modal.present();
    }
    else {
      this.globals.loginmodal();
    }
  }

  // social links

  getSocials() {
    this.server.getSocials(this.globals.businessHost).subscribe(
      (res) => {
        if (res.status) {
          if (res.business_info.social_media != null) { this.socialLinks = res.business_info.social_media; }
        }
      },
      (err) => { }
    );
  }
  visit(type) {
    if (type == 'facebook') {
      if (!this.socialLinks.hasOwnProperty('facebook')) {
        this.globals.presentToast('No Link Found');
        return;
      }
      if (this.socialLinks.hasOwnProperty('facebook')) {
        this.aib.create(this.socialLinks.facebook, '_system');
      }
    } else if (type == 'insta') {
      if (!this.socialLinks.hasOwnProperty('instagram')) {
        this.globals.presentToast('No Link Found');
        return;
      }
      if (this.socialLinks.hasOwnProperty('instagram')) {
        this.aib.create(this.socialLinks.instagram, '_system');
      }
    }
  }
  getParamsFromUrl() {
    if (!this.globals.inWeb) {
      return;
    }
    this.globals.queryParamsFromUrl = this.route.snapshot.queryParams;

    if (
      this.globals.queryParamsFromUrl &&
      this.globals.queryParamsFromUrl.hasOwnProperty('type')
    ) {
      if (this.globals.queryParamsFromUrl.hasOwnProperty('type')) {
        if (
          this.globals.dineInEnabled &&
          this.globals.queryParamsFromUrl.type == 'dine_in'
        ) {
          if (!this.globals.isOrderTypeChange) {
            this.globals.OrderType = this.globals.queryParamsFromUrl.type;
          }


          this.segmentSelect = 'dine_in';
          this.globals.dine_in = true;
        }
      }
      if (
        this.globals.queryParamsFromUrl.hasOwnProperty('table') &&
        this.globals.dineInEnabled
      ) {
        this.globals.dineInTable = this.globals.queryParamsFromUrl.table;
      } else {
        this.dineTableSelection();
      }
    }
  }

  async dineTableSelection() {
    if (!this.globals.dineInEnabled) {
      return;
    }
    const modal = await this.modalController.create({
      component: DineinTablePage,
      cssClass: 'dineTable',
      componentProps: { value: 123 },
    });

    await modal.present();
    modal.onDidDismiss().then((res) => {
      if (res.data) {
        const table = res.data.table;
        const room = res.data.room;
        this.globals.dineInTable = table.id;
        this.globals.selectedDineInTable = table;
        this.globals.selectedDineInRoom = room;
      }
    });
  }
  @HostListener('window:focus')
  onFocus() {
    if (this.globals.inWeb && this.globals.dineInEnabled) {
    }
  }
  @HostListener('document:visibilitychange')
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      // Perform actions when the tab becomes active
      if (this.globals.inWeb && this.globals.dineInEnabled) {
        // this.gellAllHoldOrders();
      }
      // Perform your desired actions here
    } else {
      // Perform actions when the tab becomes inactive
      // Perform your desired actions here
    }
  }
  gellAllHoldOrders() {
    this.server.getHoldOrders().subscribe((res) => {
      if (res.success) {
        this.globals.holdOrdersLength = res.data.length;
        this.globals.holdOrders = res.data;
      } else {
        this.globals.holdOrders = [];
        this.globals.holdOrdersLength = 0;
      }
    });
  }
  getReviews() {
    this.server.getReviews().subscribe((res) => {
      if (res.reviews) {
        this.businessReviews = res.reviews;
        this.businessReviews.forEach((item) => {
          item.color = this.getColors();
        });
      }
    });
  }
  getColors() {
    const symbols = '0123456789ABCDEF';

    let color = '#';
    for (let i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  getCart(e) {
    this.totalCalculate();
  }

  async reset() {
    const alert = await this.alertController.create({
      header: 'Alert',
      message: 'Are you sure.You want to reset?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => { },
        },
        {
          text: 'Yes',
          handler: () => {
            this.resetAllData();
            this.orderTypePage();
          },
        },
      ],
    });
    await alert.present();
  }

  resetAllData() {
    this.globals.myDate = '';
    this.customerName = '';
    const orderOnCall = JSON.parse(localStorage.getItem('orderOnCall'));

    this.localStorageService.clearAll();

    this.nativeStorage.clear().then(
      (res) => { },
      (err) => { }
    );
    this.globals.itemsInCart = [];
    this.globals.isloggedIn = false;
    this.globals.guestLogin = false;
    this.globals.takeMeToCart = false;
    this.globals.udid = '';

    localStorage.setItem('orderOnCall', JSON.stringify(orderOnCall));
  }

  async orderTypePage() {
    const modal = await this.modalController.create({
      component: OrderTypeSelectionPage,

      cssClass: 'orderTypeModal',
      mode: 'ios',
      backdropDismiss: false,
      swipeToClose: false,
    });
    modal.present();
    modal.onDidDismiss().then((data) => { });
  }

  redirectToMore(path: any) {
    if (this.globals.kiosk_flag) {
      this.kioskAlert(path);
    } else {
      this.router.navigateByUrl(path);
    }
  }
  async kioskAlert(path: any) {
    const alert = await this.alertController.create({
      cssClass: 'KioskAlert',
      header: 'Enter Secret Password',
      inputs: [
        {
          name: 'pass',
          type: 'password',
          placeholder: 'Your Password',
          cssClass: 'specialClass',
          attributes: {
            maxlength: 20,
          },
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => { },
        },
        {
          text: 'Submit',
          handler: (data) => {
            if (data.pass == '1111') {
              this.router.navigateByUrl(path);
              // let kiosk = JSON.parse(localStorage.getItem('kiosk'));
              // if (kiosk != null) {
              //   this.globals.kiosk_flag = kiosk;

              //   if (this.globals.kiosk_flag == true) {
              //     this.globals.presentToast('Kiosk mode disabled');
              //     this.globals.kiosk_flag = false;
              //     localStorage.setItem('kiosk', JSON.stringify(false));
              //   } else {
              //     this.globals.presentToast('Kiosk mode activated');
              //     this.globals.kiosk_flag = true;
              //     localStorage.setItem('kiosk', JSON.stringify(true));
              //   }
              // } else {
              //   this.globals.presentToast('Kiosk mode activated');
              //   this.globals.kiosk_flag = true;
              //   localStorage.setItem('kiosk', JSON.stringify(true));
              // }
            }
          },
        },
      ],
    });

    await alert.present();
  }

  loadScriptFromServer(scriptContent: string) {
    // Remove \r\n characters

    scriptContent = scriptContent.replace(/\r\n/g, '');
    const cleanScriptContent = scriptContent
      .replace(/<script[^>]*>/, '')
      .replace(/<\/script>/, '');

    const script = document.createElement('script');

    script.textContent = cleanScriptContent;

    document.head.appendChild(script);
  }

  onOkClick() {
    sessionStorage.setItem('showInfoPopup', JSON.stringify(false));
    this.showSchoolPopup = false;
  }
}
